const __WEBPACK_NAMESPACE_OBJECT__ = require("core-js/modules/es.string.starts-with.js");